module.exports = __webpack_public_path__ + "static/img/subcontract12.f36e9c98.png";